import { t } from 'i18next';
import { isValidIBAN } from 'ibantools';
import { isValidGUID } from 'common/utils/form.utils';
import { EQueryParams } from 'domains/accounts/constants/accounts.constants';

type TAccountFilterResult = {
  filter: { field: string | null; value?: string };
  error: string;
};

export const makeAccountFilterByGUIDOrIBAN = (value: string): TAccountFilterResult => {
  const normalizeValue = value.replace(/\s/g, '');
  const result: TAccountFilterResult = {
    filter: { field: null, value: normalizeValue },
    error: '',
  };

  if (isValidIBAN(normalizeValue)) result.filter!.field = EQueryParams.IBAN;
  if (isValidGUID(normalizeValue)) result.filter!.field = EQueryParams.WalletAccountGUID;
  if (!result.filter!.field) {
    result.filter = { field: null };
    if (normalizeValue) result.error = t('forms.validation.accountIbanOrGuid.invalid');
  }

  return result;
};
